import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import './ConfirmModal.css';

const ConfirmModal = ({
  show,
  onHide,
  onConfirm,
  title = 'Confirmar acción',
  message = '',
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  confirmVariant = 'danger',
  loading = false,
  icon = null,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="confirm-modal-dialog"
    >
      <Modal.Body className="text-center py-4 d-flex flex-column justify-content-center align-items-center">
        {icon && (
          <div className="mb-3">
            {icon}
          </div>
        )}
        <h5 className="mb-3 fw-semibold text-dark" style={{ fontSize: '1.1rem' }}>
          {title}
        </h5>
        <p className="text-muted mb-0" style={{ fontSize: '0.95rem' }}>
          {message}
        </p>
      </Modal.Body>
      <Modal.Footer className="justify-content-center border-0 pt-0 pb-4">
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={onHide}
          disabled={loading}
        >
          {cancelText}
        </Button>
        <Button
          variant={confirmVariant}
          size="sm"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? (
            <>
              <Spinner as="span" animation="border" size="sm" className="me-2" />
              Procesando...
            </>
          ) : (
            confirmText
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;